module.exports = "/lucky-balls/img/bonus_yellow/header.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/header.png
// module id = 962
// module chunks = 0